/* eslint-disable array-callback-return */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Input, Row, Select, Tag } from 'antd';
import * as SERVICE from '../../../constants/service.types';
import colorsDark from '../../../assets/colors/dark';
import { openMessage, socketEmitEvent } from '../../../redux/actions';
import regex, { NOTIFIES } from '../../../constants/system.keys';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const CreateMarkerComponent = ({
  onCreateGroup,
  onUpdateGroup,
  onDone,
  dataDevice,
  total,
  namespaceGroup,
}) => {
  const dispatch = useDispatch();
  const {
    namespace,
    isAuth,
    accountByNamespace,
    addGroupMembers,
    accountGroupMembers,
  } = useSelector((state) => state);
  const [address, setAddress] = useState();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();

  useEffect(() => {
    forceUpdate({});
  }, []);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [requestId, setRequestIdRoot] = useState(new Date().getTime());
  const [isBlock, setIsBlock] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [dataArr1, setDataArr1] = useState([]);
  const [key, setKey] = useState(Math.random());
  const [addDataReturn, setAddDataReturn] = useState();
  const [requestId1, setRequestId] = useState();
  const nameRef = useRef(null);

  const getDeviceByPage = useCallback(
    (page, size) => {
      const dataTimeRequest = new Date().getTime();
      setRequestIdRoot(dataTimeRequest);
      let data1 = {
        namespace,
        deviceType: 'camera',
        timeRequest: dataTimeRequest,
        page,
        size,
        tag: 'select_device',
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: dataTimeRequest,
        body: JSON.stringify(data1),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace]
  );

  useEffect(() => {
    if (page && isAuth === 1 && pageSize && namespace && total > 10) {
      getDeviceByPage(page - 1, total);
    }
  }, [getDeviceByPage, isAuth, namespace, page, pageSize, total]);

  useEffect(() => {
    if (namespaceGroup) {
      form.setFieldsValue({
        namespace: namespaceGroup,
      });
    }
  }, [form, namespaceGroup]);

  useEffect(() => {
    if (dataDevice && dataDevice.name && accountGroupMembers) {
      setDataList(
        accountGroupMembers.map((item) => ({
          accountId: item.accountId,
        }))
      );
      let data1 = [];
      accountGroupMembers.map((item1) => {
        data1 = [
          ...data1,
          ...(accountByNamespace.filter(
            (item2) => item1.accountId === item2.accountId
          ) || []),
        ];
      });
      setDataArr(data1);
      let sub = [...(accountByNamespace || [])];
      accountGroupMembers.map((item1) => {
        sub = _.uniqBy(
          (sub &&
            sub.length > 0 &&
            sub.filter((item2) => item1.accountId !== item2.accountId)) ||
            [],
          'accountId'
        );
      });
      setDataArr1(sub);
      form.setFieldsValue({
        name: dataDevice.name,
      });
    } else {
      setDataArr1(accountByNamespace || []);
    }
  }, [accountByNamespace, accountGroupMembers, dataDevice, form]);

  useEffect(() => {
    if (addGroupMembers && addGroupMembers.requestId === requestId1) {
      setAddDataReturn(addGroupMembers);
    }
  }, [addGroupMembers, requestId1]);

  useEffect(() => {
    if (addDataReturn) {
      const { result, data, message } = addDataReturn;
      if (result === -3) {
        form.setFields([
          {
            name: 'address',
            errors: [message],
          },
        ]);
      }
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        onDone(data);
      }
    }
  }, [addDataReturn, form, onDone]);

  useEffect(() => {
    if (nameRef.current) {
      setTimeout(() => {
        nameRef.current.input.focus();
      }, 1);
    }
  }, [nameRef]);

  const onFinish = (values) => {
    let current = new Date().getTime();
    if (dataDevice && dataDevice.name) {
      setRequestId(current);
      return onUpdateGroup(current, values, dataDevice?.id, dataDevice.name);
    } else {
      setRequestId(current);
      return onCreateGroup(current, values, dataList);
    }
  };
  useEffect(() => {
    return () => {
      setAddress(null);
      setIsBlock(false);
    };
  }, []);

  const onChangeSearch = (value) => {
    if (dataDevice && dataDevice.name) {
      let data = {
        namespace,
        groupId: dataDevice.id,
        accountId: Number(value),
        indexOf: dataArr.length + 1,
      };
      let dataObj = {
        appServiceType: SERVICE.ADD_ACCOUNT_GROUP_MEMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
    const dataItem =
      dataArr1.find((x) => x.accountId === Number(value)) &&
      dataArr1.find((x) => x.accountId === Number(value));
    setDataArr([...dataArr, dataItem]);
    setDataList([...dataList, { accountId: Number(value) }]);
    const sub = _.uniqBy(
      (dataArr1 &&
        dataArr1.length > 0 &&
        dataArr1.filter((item) => item.accountId !== Number(value))) ||
        [],
      'accountId'
    );
    setDataArr1(sub);
    setKey(Math.random());
  };

  const memberRoleColors = (roleName) => {
    switch (roleName) {
      case 'admin':
        return colorsDark.$online;
      default:
        return colorsDark.$offline;
    }
  };

  return (
    <div className="create-marker-component">
      <Form
        className="select-placeholder"
        form={form}
        {...layout}
        onFinish={onFinish}
        name="form_in_modal"
      >
        <Form.Item
          style={{ justifyContent: 'center' }}
          name="name"
          rules={[
            {
              required: true,
              message: t('Please input the name of the group!'),
            },
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input ref={nameRef} placeholder={t('Name of the group')} />
        </Form.Item>
        <Form.Item
          style={{ justifyContent: 'center' }}
          name="namespace"
          rules={[
            {
              required: true,
              message: t('Please input the namespace!'),
            },
            {
              pattern: regex.isurl,
              message: t('Please input the namespace!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input disabled placeholder={t('Namespace')} />
        </Form.Item>
        <Form.Item style={{ justifyContent: 'center' }}>
          <Select
            showSearch
            key={key}
            getPopupContainer={(trigger) => trigger.parentElement}
            value={t('Add member')}
            optionFilterProp="children"
            onChange={onChangeSearch}
            filterOption={(input, option) => {
              const data =
                option?.children?.props?.children?.[0]?.props?.children?.props?.children?.join(
                  ''
                ) || '';
              return data.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }}
          >
            {dataArr1.map((d) => (
              <Select.Option key={d.accountId}>
                <Row gutter={8}>
                  <Col span={18}>
                    <div
                      style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                      {d.phonenumber} {d.fullName ? `- ${d.fullName}` : ''}
                    </div>
                  </Col>
                  <Col span={6}>
                    <Tag color={memberRoleColors(d.role)}>
                      {d.role && d.role.toUpperCase()}
                    </Tag>
                  </Col>
                </Row>
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <div className="create-btn">
          <Form.Item shouldUpdate={true}>
            <Button htmlType="submit" disabled={isBlock}>
              {dataDevice && dataDevice.name ? t('Update') : t('Create')}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default CreateMarkerComponent;
